import type { Obj } from "./api";

// Display-only backfill for historical snapshots and Analytics rows whose saved
// capabilities predate registry .2. Exact verified IDs; never infer future models.
const ignoredGeminiSampling = new Set([
  "gemini-3.5-flash-lite",
  "gemini-3.6-flash",
  "gemini-3.7-flash",
  "gemini-3.8-flash",
]);
const modelSettings = (model: Obj) => model.settings || model;

export function samplingIgnored(
  model: Obj,
  field: "temperature" | "top_p",
  provider?: string,
): boolean {
  if (model.capabilities?.[field]?.ignored === true) return true;
  const settings = modelSettings(model);
  const modelId = model.api_model || model.model_id || settings.model_id;
  return (
    (provider || model.provider) === "gemini" &&
    ignoredGeminiSampling.has(modelId)
  );
}

export function temperatureLabel(model: Obj, provider?: string): string {
  if (samplingIgnored(model, "temperature", provider))
    return "Temperature ignored by provider";
  const value = modelSettings(model).temperature;
  return value == null ? "Default temperature" : `Temperature ${value}`;
}

export function reasoningLabel(model: Obj): string {
  const settings = modelSettings(model);
  if (settings.reasoning_effort === "none") {
    const modelId = model.api_model || model.model_id || settings.model_id;
    return modelId === "claude-haiku-5-5" ? "Thinking Off" : "Reasoning Off";
  }
  if (settings.reasoning_effort)
    return String(settings.reasoning_effort).replace(/^./, x => x.toUpperCase());
  return settings.thinking_budget != null
    ? `Thinking budget ${settings.thinking_budget}`
    : "Default reasoning";
}

export function topPLabel(model: Obj, provider?: string): string | null {
  const value = modelSettings(model).top_p;
  if (samplingIgnored(model, "top_p", provider)) return "Top-p ignored by provider";
  return value == null ? null : `Top-p ${value}`;
}
